import PropTypes from 'prop-types';
import ErrorAlert from '../common/ErrorAlert';

/** Below the grid: Load More button, its inline error, or the "seen all" note. */
const LoadMoreFooter = ({ pagination, loadingMore, loadMoreError, onLoadMore, onDismissError }) => (
  <div className="container mt-4 mb-4">
    <div className="row">
      <div className="col-12 text-center">
        {loadMoreError && (
          <div className="mb-3">
            <ErrorAlert
              error={loadMoreError}
              title="Couldn’t load more deals"
              onRetry={() => { onDismissError(); onLoadMore(); }}
              onDismiss={onDismissError}
            />
          </div>
        )}

        {pagination.hasNextPage && (
          <button
            type="button"
            className="btn btn-primary btn-lg d-flex align-items-center justify-content-center mx-auto load-more-btn"
            onClick={onLoadMore}
            disabled={loadingMore}
          >
            {loadingMore ? (
              <>
                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                <span>Loading More...</span>
              </>
            ) : (
              <span>Load More Deals</span>
            )}
          </button>
        )}

        {!pagination.hasNextPage && pagination.totalDeals > 0 && (
          <div className="alert alert-info d-inline-block seen-all-note">
            <i className="fas fa-check-circle me-2"></i>
            You&apos;ve seen all available deals!
          </div>
        )}
      </div>
    </div>
  </div>
);

LoadMoreFooter.propTypes = {
  pagination: PropTypes.object.isRequired,
  loadingMore: PropTypes.bool,
  loadMoreError: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onLoadMore: PropTypes.func.isRequired,
  onDismissError: PropTypes.func.isRequired,
};

export default LoadMoreFooter;
